import { render, staticRenderFns } from "./pellets-herstellung.vue?vue&type=template&id=ffacee90"
import script from "./pellets-herstellung.vue?vue&type=script&lang=ts"
export * from "./pellets-herstellung.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports